// src/admindashboardutils/utils/fetchUtils.js
import { calculateCallDuration, isToday, getFullDayName } from "./timeUtils";

const isDateInRange = (dateStr, startDate, endDate) => {
  if (!dateStr) return false;
  const callDate = new Date(dateStr);
  const start = new Date(startDate);
  const end = new Date(endDate);
  // Normalize dates to start of day for comparison
  callDate.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999); // Include end of day
  return callDate >= start && callDate <= end;
};

export const fetchCallHistory = async (
  user,
  setCallData,
  setPieData,
  setAverageCallTime,
  setLoading,
  setError,
  startDate,
  endDate
) => {
  try {
    // Ideally, filter by date range server-side
    const start = startDate.toISOString().split("T")[0];
    const end = endDate.toISOString().split("T")[0];
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_API}/api/call-history?userId=${user.id}&role=${user.role}&startDate=${start}&endDate=${end}`
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const data = await response.json();

    // Filter calls within the date range (client-side fallback if server doesn't filter)
    const filteredCalls = data.filter((call) => isDateInRange(call.createdAt, startDate, endDate));

    const sentimentCounts = { disconnected: 0, dnc: 0, positive: 0, negative: 0 };
    let totalCallTime = 0;
    let callCount = 0;

    filteredCalls.forEach((call) => {
      const sentiment = call.agentSentiment || "";
      if (sentiment === "Negative") sentimentCounts.negative += 1;
      else if (sentiment === "Positive") sentimentCounts.positive += 1;
      else if (sentiment === "Negative/DND") sentimentCounts.dnc += 1;
      else if (sentiment === "") sentimentCounts.disconnected += 1;

      if (call.startTime && call.endTime) {
        const duration = calculateCallDuration(call.startTime, call.endTime);
        totalCallTime += duration;
        callCount += 1;
      }
    });

    const avgCallTime = callCount > 0 ? Math.round(totalCallTime / callCount) : 0;
    const totalCalls = Object.values(sentimentCounts).reduce((sum, count) => sum + count, 0);

    const updatedPieData = [
      { name: "Disconnected Calls", value: sentimentCounts.disconnected, color: "#DC143C" },
      { name: "DNC Calls", value: sentimentCounts.dnc, color: "#FFA500" },
      { name: "Positive Calls", value: sentimentCounts.positive, color: "#9ACD32" },
      { name: "Negative Calls", value: sentimentCounts.negative, color: "#FF69B4" },
    ].map((item) => ({
      ...item,
      percent: totalCalls > 0 ? item.value / totalCalls : 0,
    }));

    setPieData(updatedPieData);
    setCallData(filteredCalls);
    setAverageCallTime(avgCallTime);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching call history:", error);
    setError("Failed to load call history. Please try again.");
    setLoading(false);
  }
};


export const fetchPositiveCallData = async (
  setConversionBarData,
  setPositiveCallData,
  setLoading,
  setError,
  startDate,
  endDate
) => {
  try {
    const start = startDate.toISOString().split("T")[0];
    const end = endDate.toISOString().split("T")[0];
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_API}/api/positive-calls/allpositives-calls?startDate=${start}&endDate=${end}`
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const data = await response.json();
    const callData = data.data || [];

    // Filter data for the date range (client-side fallback)
    const filteredData = callData.filter((call) => isDateInRange(call.createdAt, startDate, endDate));

    // Create array for days in the range
    const dailyCounts = [];
    const startDay = new Date(startDate);
    const endDay = new Date(endDate);
    for (let date = new Date(startDay); date <= endDay; date.setDate(date.getDate() + 1)) {
      const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
      dailyCounts.push({ date: new Date(date), dayName, count: 0 });
    }

    // Count calls for each day
    filteredData.forEach((call) => {
      const callDate = new Date(call.createdAt);
      callDate.setHours(0, 0, 0, 0);
      const matchingDay = dailyCounts.find(
        (day) => day.date.toDateString() === callDate.toDateString()
      );
      if (matchingDay) matchingDay.count++;
    });

    // Format data for the bar chart (use last 7 days for display)
    const lastSevenDays = dailyCounts.slice(-7).map((day) => ({
      day: day.dayName,
      conversions: day.count,
    }));

    setConversionBarData(lastSevenDays.length === 7 ? lastSevenDays : [
      { day: "Mon", conversions: 0 },
      { day: "Tue", conversions: 0 },
      { day: "Wed", conversions: 0 },
      { day: "Thurs", conversions: 0 },
      { day: "Fri", conversions: 0 },
      { day: "Sat", conversions: 0 },
      { day: "Sun", conversions: 0 },
    ]);
    setPositiveCallData(filteredData);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching positive call data:", error);
    setError("Failed to load positive call data. Please try again.");
    setLoading(false);
  }
};

        // data.forEach((call) => {
        //     const sentiment = call.agentSentiment || "";
        //     if (sentiment === "Negative") sentimentCounts.negative += 1;
        //     else if (sentiment === "Positive") sentimentCounts.positive += 1;
        //     else if (sentiment === "Negative/DND") sentimentCounts.dnc += 1;
        //     else if (sentiment === "") sentimentCounts.disconnected += 1;
        // });

        // todayCalls.forEach((call) => {
        //     if (call.startTime && call.endTime) {
        //         const duration = calculateCallDuration(call.startTime, call.endTime);
        //         totalCallTime += duration;
        //         callCount += 1;
        //     }
        // });


        // data.forEach((call) => {
        //     const sentiment = call.agentSentiment || "";
        //     if (sentiment === "Negative") sentimentCounts.negative += 1;
        //     else if (sentiment === "Positive") sentimentCounts.positive += 1;
        //     else if (sentiment === "Negative/DND") sentimentCounts.dnc += 1;
        //     else if (sentiment === "") sentimentCounts.disconnected += 1;
        //   });
      
        //   filteredCalls.forEach((call) => {
        //     if (call.startTime && call.endTime) {
        //       const duration = calculateCallDuration(call.startTime, call.endTime);
        //       totalCallTime += duration;
        //       callCount += 1;
        //     }
        //   });

//         filteredCalls.forEach((call) => {
//             const sentiment = call.agentSentiment || "";
//             if (sentiment === "Negative") sentimentCounts.negative += 1;
//             else if (sentiment === "Positive") sentimentCounts.positive += 1;
//             else if (sentiment === "Negative/DND") sentimentCounts.dnc += 1;
//             else if (sentiment === "") sentimentCounts.disconnected += 1;
      
//             if (call.startTime && call.endTime) {
//               const duration = calculateCallDuration(call.startTime, call.endTime);
//               totalCallTime += duration;
//               callCount += 1;
//             }
//           });


//         const avgCallTime = callCount > 0 ? Math.round(totalCallTime / callCount) : 0;
//         const totalCalls = Object.values(sentimentCounts).reduce((sum, count) => sum + count, 0);

//         const updatedPieData = [
//             { name: "Disconnected Calls", value: sentimentCounts.disconnected, color: "#DC143C" },
//             { name: "DNC Calls", value: sentimentCounts.dnc, color: "#FFA500" },
//             { name: "Positive Calls", value: sentimentCounts.positive, color: "#9ACD32" },
//             { name: "Negative Calls", value: sentimentCounts.negative, color: "#FF69B4" },
//         ].map((item) => ({
//             ...item,
//             percent: totalCalls > 0 ? item.value / totalCalls : 0,
//         }));
//         // console.log("Updated pie data:", updatedPieData);
//         setPieData(updatedPieData);
//         // setCallData(data);
//         setCallData(filteredCalls);
//         setAverageCallTime(avgCallTime);
//         setLoading(false);
//     } catch (error) {
//         // console.error("Error fetching call history:", error);
//         setError("Failed to load call history. Please try again.");
//         setLoading(false);
//     }
// };



export const calculateConversionPercentage = (callData) => {
    if (!callData || callData.length === 0) return 0;
    const totalCalls = callData.length; // Should be 12
    const connectedCalls = callData.filter(
        (call) => call.agentSentiment && call.agentSentiment.trim() !== ""
    ).length; // Should be 10
    const conversionPercentage = totalCalls > 0 ? connectedCalls / totalCalls : 0;
    return conversionPercentage;
};



// export const fetchQueueData = async (setQueueData, setLoading, setError) => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/agents/allagents`);
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//         const data = await response.json();

//         const mappedQueueData = data
//             .map((agent) => ({
//                 name: agent.name,
//                 status: agent.status,
//                 color:
//                     agent.status === "engaged"
//                         ? "text-green-600"
//                         : agent.status === "available"
//                             ? "text-yellow-600"
//                             : "text-gray-500",
//             }))
//             .sort((a, b) => {
//                 if (a.status === "engaged" && b.status !== "engaged") return -1;
//                 if (a.status !== "engaged" && b.status === "engaged") return 1;
//                 if (a.status === "available" && b.status !== "available") return -1;
//                 if (a.status !== "available" && b.status === "available") return 1;
//                 return 0;
//             });

//         setQueueData(mappedQueueData);
//         setLoading(false);
//     } catch (error) {
//         console.error("Error fetching queue data:", error);
//         setError("Failed to load queue data. Please try again.");
//         setLoading(false);
//     }
// };

export const fetchQueueData = async (setQueueData, setLoading, setError) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/agents/allagents`);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const data = await response.json();
    console.log("Fetched queue data:", data);

    const mappedQueueData = data
      .map((agent) => ({
        name: agent.name,
        status: agent.status,
        color:
          agent.status === "available"
            ? "text-green-600"
            : agent.status === "engaged"
            ? "text-yellow-600"
            : "text-gray-500", // offline
      }))
      .sort((a, b) => {
        if (a.status === "engaged" && b.status !== "engaged") return -1;
        if (a.status !== "engaged" && b.status === "engaged") return 1;
        if (a.status === "available" && b.status !== "available") return -1;
        if (a.status !== "available" && b.status === "available") return 1;
        return 0;
      });

    setQueueData(mappedQueueData);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching queue data:", error);
    setError("Failed to load queue data. Please try again.");
    setLoading(false);
  }
};





// export const fetchPositiveCallData = async (
//     setConversionBarData,
//     setPositiveCallData,
//     setLoading,
//     setError,
//     selectedDate // Add selectedDate as a parameter
//   ) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_SERVER_API}/api/positive-calls/allpositives-calls`
//       );
//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//       const data = await response.json();
//       const callData = data.data || [];
//       console.log("Fetched call data:", callData);
  
//       // Use selectedDate from the dashboard, default to today if not provided
//       const baseDate = selectedDate ? new Date(selectedDate) : new Date();
//       baseDate.setHours(0, 0, 0, 0); // Normalize to start of day
  
//       const sixDaysAgo = new Date(baseDate);
//       sixDaysAgo.setDate(baseDate.getDate() - 6); // 6 days before baseDate
  
//       // Filter data for the last 7 days based on baseDate
//       const filteredData = callData.filter((call) => {
//         const callDate = new Date(call.createdAt);
//         callDate.setHours(0, 0, 0, 0); // Normalize call date to start of day
//         return callDate >= sixDaysAgo && callDate <= baseDate;
//       });
  
//       // Create array for 7 days starting from 6 days ago
//       const dailyCounts = [];
//       for (let i = 0; i < 7; i++) {
//         const date = new Date(baseDate);
//         date.setDate(baseDate.getDate() - (6 - i));
//         const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
//         dailyCounts.push({ date, dayName, count: 0 });
//       }
  
//       // Count calls for each day
//       filteredData.forEach((call) => {
//         const callDate = new Date(call.createdAt);
//         callDate.setHours(0, 0, 0, 0); // Normalize to start of day
//         const dayIndex = Math.floor((baseDate - callDate) / (1000 * 60 * 60 * 24));
//         if (dayIndex >= 0 && dayIndex < 7) {
//           dailyCounts[6 - dayIndex].count++; // Reverse order: oldest first
//         }
//       });
  
//       // Format data for the bar chart
//       const updatedConversionBarData = dailyCounts.map((day) => ({
//         day: day.dayName,
//         conversions: day.count,
//       }));
  
//       setConversionBarData(updatedConversionBarData);
//       setPositiveCallData(callData);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching positive call data:", error);
//       setError("Failed to load positive call data. Please try again.");
//       setLoading(false);
//     }
//   };